import $ from 'jquery'
import select2 from 'select2'

window.$ = window.jQuery = $
select2($)